var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer Service"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.875 18V12C2.875 9.61305 3.7837 7.32387 5.4012 5.63604C7.0187 3.94821 9.21251 3 11.5 3C13.7875 3 15.9813 3.94821 17.5988 5.63604C19.2163 7.32387 20.125 9.61305 20.125 12V18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.125 19C20.125 19.5304 19.9231 20.0391 19.5636 20.4142C19.2042 20.7893 18.7167 21 18.2083 21H17.25C16.7417 21 16.2542 20.7893 15.8947 20.4142C15.5353 20.0391 15.3333 19.5304 15.3333 19V16C15.3333 15.4696 15.5353 14.9609 15.8947 14.5858C16.2542 14.2107 16.7417 14 17.25 14H20.125V19ZM2.875 19C2.875 19.5304 3.07693 20.0391 3.43638 20.4142C3.79582 20.7893 4.28334 21 4.79167 21H5.75C6.25833 21 6.74584 20.7893 7.10529 20.4142C7.46473 20.0391 7.66667 19.5304 7.66667 19V16C7.66667 15.4696 7.46473 14.9609 7.10529 14.5858C6.74584 14.2107 6.25833 14 5.75 14H2.875V19Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.6e8f47527c7c66c4d662e02ac48db300.svg";
export { ForwardRef as ReactComponent };